import React from 'react';
import { useInput, InputProps } from 'react-admin';
import { TSupplierFeature } from '@/api';
import { SupplierFeaturesTree } from './SupplierFeaturesTree';
import { SUPPLIER_FEATURES } from '@/constants/supplier-features';
import { getAllFeaturesAsEnabled } from '@/utils/supplier-features';

interface SupplierFeaturesInputProps extends Omit<InputProps, 'source'> {
  source: string;
}

export const SupplierFeaturesInput: React.FC<SupplierFeaturesInputProps> = (props) => {
  const { field } = useInput(props);
  
  const handleChange = (features: TSupplierFeature[]) => {
    field.onChange(features);
  };

  // If field.value is undefined, show all features as enabled (current behavior)
  // Otherwise, show the specific features that are configured
  const currentValue = field.value === undefined 
    ? getAllFeaturesAsEnabled(SUPPLIER_FEATURES)
    : field.value || [];

  return (
    <SupplierFeaturesTree
      features={SUPPLIER_FEATURES}
      value={currentValue}
      onChange={handleChange}
      readOnly={false}
    />
  );
};